import { FC, ReactNode } from 'react';

import homecook_logo from '../../assets/img/homecook_logo.png';

type AuthCardProps = {
  title: string;
  subtitle?: ReactNode;
  children: ReactNode;
  showLogo?: boolean;
  className?: string;
  /** Small print rendered under the form, e.g. reassurance or legal links. */
  footNote?: ReactNode;
};

/** White auth panel used on the logged-out landing and OTP screen. */
export const AuthCard: FC<AuthCardProps> = ({
  title,
  subtitle,
  children,
  showLogo = true,
  className = '',
  footNote,
}) => (
  <div className={`page-card w-full px-8 py-8 shadow-[0_18px_45px_rgba(1,56,71,0.14)] sm:px-9 ${className}`}>
    {showLogo ? (
      <img src={homecook_logo} alt="HomeCook" className="mx-auto mb-3 h-auto w-[76px]" />
    ) : null}
    <h1 className="font-raleway text-center text-[22px] font-bold text-ink">{title}</h1>
    {subtitle ? (
      <p className="mx-auto mt-2 max-w-[28rem] text-center font-open-sans text-[15px] font-normal leading-[1.55] text-[#4D4D4D]">{subtitle}</p>
    ) : null}
    <div className="mt-5">{children}</div>
    {footNote ? (
      <div className="mt-5 border-t border-[#E9E9E9] pt-4 text-center font-open-sans text-[11px] leading-relaxed text-muted">
        {footNote}
      </div>
    ) : null}
  </div>
);

export default AuthCard;
